import PropTypes from 'prop-types'
import React from 'react'

import { H6, P } from '@PipelineDeals/shared-react-components'
import { Section, Row, RowIcon } from 'components/BusinessCard/components/StyledComponents'
import { useBusinessCard } from 'components/BusinessCard/context'

const getPrefixedAddress = (record, addressType) => {
  const prefix = addressType.length ? `${addressType}_` : ''
  const label = addressType.length ? `${addressType} address` : 'address'
  const arr = [record[`${prefix}address_1`], record[`${prefix}address_2`]]

  if (record[`${prefix}city`] || record[`${prefix}state`] || record[`${prefix}postal_code`]) {
    let addr = [record[`${prefix}city`], record[`${prefix}state`]].filter(el => el).join(', ')
    if (record[`${prefix}postal_code`]) addr = addr.concat(` ${record[`${prefix}postal_code`]}`)
    arr.push(addr)
  }
  arr.push(record[`${prefix}country`], record[`${prefix}address_google_maps_url`])
  return { label: label, formattedArray: arr }
}

const getNestedAddress = (data, addressType) => {
  const address = data.formatted_array
  address.push(data.google_maps_url)
  return { label: addressType, formattedArray: address }
}

const Addresses = ({ addressTypes }) => {
  const { cardMeta: { showOnlyFields }, resource } = useBusinessCard()
  const record = resource

  const addresses = addressTypes
    .filter(addressType => showOnlyFields.includes(addressType) || showOnlyFields.includes(`${addressType}_address`))
    .map((addressType) => {
      if (record[`${addressType}_address`] && record[`${addressType}_address`].has_address) {
        return getNestedAddress(record[`${addressType}_address`], addressType)
      } else if (record[addressType] && record[addressType].has_address) {
        return getNestedAddress(record[addressType], addressType)
      } else if (record[`has_${addressType}_address`] || addressType === '') {
        return getPrefixedAddress(record, addressType)
      }
    }).filter(Boolean)

  if (!addresses.length && showOnlyFields.includes('address') && record.address_1) {
    addresses.push(getPrefixedAddress(record, ''))
  }

  if (!addresses.length) return null

  return (
    <>
      {
        addresses.map(({ label, formattedArray }) => {
          const googleMapsUrl = formattedArray.pop()
          const displayAddress = formattedArray.filter(Boolean).join(', ')

          return (
            <Section key={label}>
              <H6>{label}</H6>
              <Row>
                <P>{displayAddress}</P>
                <a
                  href={googleMapsUrl}
                  target="_BLANK"
                  rel="noopener noreferrer"
                >
                  <RowIcon className="fas fa-map-marked-alt" />
                </a>
              </Row>
            </Section>
          )
        })
      }
    </>
  )
}

Addresses.propTypes = {
  addressTypes: PropTypes.array.isRequired
}

export default Addresses
